<template>
	<div class="">
		<ModalBox v-model="legacyModalVisible" size="md" hide-close header-class="!hidden" wrapper-classes="lg:h-auto lg:max-h-none p-6">

			<div class="flex flex-wrap">
				<div class="w-full"><h3 class="text-s-xl">Share Folder Playlist</h3></div>
			</div>
			<div class="flex flex-wrap">
				<div class="text-s-l text-dark-8 mb-4 w-full">Everyone who has the link will be able to watch all the videos this folder contains.</div>
			</div>
			<div class="flex flex-wrap">
				<div class="w-full">
					<label class="text-s-s text-dark-8" for="">iFrame Widget</label>
					<div class="mb-2">
						<FormRadio v-model="selectedWidget" name="selected-widget" inputValue="responsive" label="Responsive" />
						<FormRadio v-model="selectedWidget" name="selected-widget" inputValue="fixed" label="Fixed Size" />
					</div>
				</div>
			</div>
			<div class="mb-3 flex flex-wrap">
				<div class="w-full">
					<div class="flex items-center gap-x-2 w-full">
            <FormInput
              label="iFrame Widget"
              :modelValue="iframe"
              readonly
              class="flex-1"
              customClasses="!bg-transparent !border-0"
              @click="copyIframe()"
            />
              <FormButton class="py-1 px-2 inline-flex items-center justify-center relative" type="light" :isIcon="true" @click="copyIframe()">
                <icon-base fill="none" width="20" height="20" width-view-box="20" height-view-box="20">
									<icon-copy-stroke />
								</icon-base>
              </FormButton>
          </div>
				</div>
			</div>
			<div class="mb-4 flex flex-wrap">
				<div class="w-full">
					<div class="flex items-center gap-x-2 w-full">
            <FormInput
              label="Embed Url"
              :modelValue="embedUrl"
              readonly
              class="flex-1"
              customClasses="!bg-transparent !border-0"
              @click="copyEmbedUrl()"
            />
              <FormButton class="py-1 px-2 inline-flex items-center justify-center relative" type="light" :isIcon="true" @click="copyEmbedUrl()">
                <icon-base fill="none" width="20" height="20" width-view-box="20" height-view-box="20">
									<icon-copy-stroke />
								</icon-base>
              </FormButton>
							<FormButton :href="embedUrl" target="_blank" class="py-1 px-2 inline-flex items-center justify-center relative" type="light" :isIcon="true">
                <icon-base fill="none">
									<icon-external-link-outline />
								</icon-base>
              </FormButton>
          </div>
				</div>
			</div>
			<div class="flex flex-wrap">
				<div class="w-full" :class="buttonAlignment">
					<FormButton
						type="secondary"
						size="md"
						class="ml-auto"
						@click="hideLegacyModal()"
					>
						Close
					</FormButton>
				</div>
			</div>
		
</ModalBox>
	</div>
</template>

<script>
import ModalBox from '@/components/modals/ModalBox.vue'
import { legacyModalBridgeMixin } from '@/composables/useLegacyModalBridge'
import FormInput from '@/components/Atoms/FormInput.vue'
import FormRadio from '@/components/Atoms/FormRadio.vue'
import FormButton from '@/components/Atoms/FormButton.vue'
import { track, EVENTS } from '@/lib/tracking'
import IconBase from '@/components/icon/IconBase.vue'
import IconCopyStroke from '@/components/icon/IconCopyStroke.vue'
import IconExternalLinkOutline from '@/components/icon/IconExternalLinkOutline.vue'
export default {
	name: 'SharePlayListModal',
	mixins: [legacyModalBridgeMixin],
	legacyModalId: 'share-playlist',
	components: {
		ModalBox,
		FormInput,
		FormRadio,
		FormButton,
		IconBase,
		IconCopyStroke,
		IconExternalLinkOutline,
	},
	props: {
		modalId: {
			type: String,
			default: 'modal-alert'
		},
		okText: {
			type: String,
			default: 'Yes'
		},
		buttonAlignment: {
			type: String,
			default: ''
		},
		stream: {
			type: Object,
		},
		streamKey: {
			type: String || undefined
		}
	},
	data() {
		return {
			processing: false,
			selectedWidget: 'responsive'
		};
	},
	computed: {
		iframe() {
			let code = ''
			if (this.stream?.liveParent && this.selectedWidget === 'responsive') {
				code = '<iframe src="https://player.castr.com/' + this.streamKey + '?playlist=true" width="100%" style="aspect-ratio: 16/9; min-height: 340px;" frameborder="0" scrolling="yes" allow="autoplay; encrypted-media" allowfullscreen  webkitallowfullscreen mozallowfullscreen oallowfullscreen msallowfullscreen></iframe>'
			} else if (this.stream?.liveParent && this.selectedWidget === 'fixed') {
				code = '<iframe src="https://player.castr.com/' + this.streamKey + '?playlist=true" width="590" height="620" frameborder="0" scrolling="yes" allow="autoplay; encrypted-media" allowfullscreen webkitallowfullscreen mozallowfullscreen oallowfullscreen msallowfullscreen></iframe>'
			} else if (!this.stream?.liveParent && this.selectedWidget === 'responsive') {
				code = '<iframe src="https://player.castr.com/vod/' + this.stream?._id + '?playlist=true" width="100%" style="aspect-ratio: 16/9; min-height: 340px;" frameborder="0" scrolling="yes" allow="autoplay; encrypted-media" allowfullscreen  webkitallowfullscreen mozallowfullscreen oallowfullscreen msallowfullscreen></iframe>'
			} else if (!this.stream?.liveParent && this.selectedWidget === 'fixed') {
				code = '<iframe src="https://player.castr.com/vod/' + this.stream?._id + '?playlist=true" width="590" height="620" frameborder="0" scrolling="yes" allow="autoplay; encrypted-media" allowfullscreen webkitallowfullscreen mozallowfullscreen oallowfullscreen msallowfullscreen></iframe>'
			}
			return code
		},
		embedUrl() {
			let url = ''
			if (this.stream?.liveParent) {
				url = 'https://player.castr.com/' + this.streamKey + '?playlist=true'
			} else url = 'https://player.castr.com/vod/' + this.stream?._id + '?playlist=true'
			return url
		}
	},
	methods: {
		onConfirm() {
			this.$emit('modal-confirm');
			this.dismiss();
		},
		dismiss() {
			this.hideLegacyModal();
			// lazy clear
			setTimeout(() => { this.processing = false; }, 1000);
		},
		clipboardCopy(text) {
			navigator.clipboard.writeText(text)
			this.$notify({ group: 'info', text: 'Copied to clipboard' });
		},
		copyIframe() {
			this.clipboardCopy(this.iframe)
			track(EVENTS.EMBED_CODE_COPIED, { contentType: 'playlist', copyType: this.selectedWidget })
		},
		copyEmbedUrl() {
			this.clipboardCopy(this.embedUrl)
			track(EVENTS.CONTENT_URL_COPIED, { contentType: 'playlist' })
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
